import * as React from 'react'

import type { PopoverOrigin } from '@mui/material/Popover'

import { MoreButton as MoreButtonAtom } from '@sales-center/components'

type Props = {
  remove: () => void
  edit: () => void
  dataTestId?: string
}

const anchorOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
}

const transformOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
}

export function ConditionActionsButton(props: Props) {
  const { remove, edit, dataTestId } = props

  return (
    <MoreButtonAtom
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      dataTestId={dataTestId}
      options={[
        { label: 'Edit', onClick: edit, dataTestId: 'conditionEditOption' },
        {
          label: 'Delete',
          onClick: remove,
          dataTestId: 'conditionDeleteOption',
        },
      ]}
      horizontal={false}
    />
  )
}
